export default __webpack_public_path__ + "static/media/htmlcss_icon.957da0bb.webp";